import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/design/design/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3>{`General`}</h3>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/accessibility-at-github"
      }}>{`Accessibility at GitHub`}</a></h4>
    <p>{`Get started with accessibility at GitHub.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/guidelines"
      }}>{`Guidelines`}</a></h4>
    <p>{`Basic guidelines for designers when creating or updating features.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/tools"
      }}>{`Tools`}</a></h4>
    <p>{`Tools to help you design accessible interfaces.`}</p>
    <h3>{`Specific`}</h3>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/alternative-text-for-images"
      }}>{`Alternative text for images`}</a></h4>
    <p>{`Alternative text on images allows assistive technology like screen readers to understand the purpose of an image on a page or allow them to skip it if purely decorative.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/announcements"
      }}>{`Assistive technology announcements`}</a></h4>
    <p>{`Events like toasts and status messages are visually communicated to GitHub users. Making sure those announcements are read via assistive technology allows users with low or no vision to get that status information.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/descriptive-buttons"
      }}>{`Descriptive buttons`}</a></h4>
    <p>{`Labeling buttons properly let's users know what will happen when they activate the control, lessens errors, and
increases confidence.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/focus-management"
      }}>{`Focus management`}</a></h4>
    <p>{`Managing focus within a page or application is essential for users to successfully navigate, complete actions,
and understand where they are.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/headings"
      }}>{`Headings`}</a></h4>
    <p>{`Headings play a critical role in communicating the structure of a page. Find out why they're critical and how to
create an accessible hierarchy in your pages.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/links"
      }}>{`Links`}</a></h4>
    <p>{`Links help us navigate a website. Learn how to style links appropriately to keep them usable by all.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/semantic-html"
      }}>{`Semantic HTML`}</a></h4>
    <p>{`Understand when and how to use semantic HTML to improve the experience of the largest number of users possible.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/text-resize-and-respacing"
      }}>{`Text resize and respacing`}</a></h4>
    <p>{`People on the web should be able to resize text to improve legibility without blocking or obscuring any other
part of the UI.`}</p>
    <h4><a parentName="h4" {...{
        "href": "/guides/accessibility/tooltip-alternatives"
      }}>{`Tooltip alternatives`}</a></h4>
    <p>{`Most UI cases don't call for tooltips. Learn some alternative methods to use in place of tooltips.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      